import moment from 'moment'
import { createSelector } from 'reselect'

const getUntilDate  = state => state.ui.untilDate
const getTrackedDays = state => state.ui.trackedDays

const getTimeInterval = (untilDate, trackedDays) => {

  const untilDateIsToday = untilDate === moment().format('YYYYMMDD')
  const endOfDay = moment(untilDate, 'YYYYMMDD').endOf('day').unix()
  const untilTime = untilDateIsToday
    ? moment().unix()
    : endOfDay

  return({
    start: untilTime - ( trackedDays *  60 * 60 * 24 ),
    end: untilTime
  })
}

export default createSelector([getUntilDate, getTrackedDays], getTimeInterval)



// WEBPACK FOOTER //
// ./src/selectors/timeInterval.js